module.exports = __webpack_public_path__ + "static/schoolsforasia_activity2@2x-ae65ebb187253ccd5088332072a274dd.png";